import { render, staticRenderFns } from "./ProductOption.vue?vue&type=template&id=12286d6c&scoped=true&"
import script from "./ProductOption.vue?vue&type=script&lang=ts&"
export * from "./ProductOption.vue?vue&type=script&lang=ts&"
import style0 from "./ProductOption.vue?vue&type=style&index=0&id=12286d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12286d6c",
  null
  
)

export default component.exports